import {apiUrl, get, UnderwriterListItem} from "./common";

const baseUrl = `${apiUrl}/admin`;

export async function getAllUnderwritersList() {
  return await get<UnderwriterListItem[]>(`${baseUrl}/underwriters`);
}
